// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'
import {TextSelection} from './text-selection.js'

export class TextAnchor {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): TextAnchor {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsTextAnchor(bb: flatbuffers.ByteBuffer, obj?: TextAnchor): TextAnchor {
    return (obj || new TextAnchor()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsTextAnchor(bb: flatbuffers.ByteBuffer, obj?: TextAnchor): TextAnchor {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new TextAnchor()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  textField(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  selection(obj?: TextSelection): TextSelection | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new TextSelection()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  static startTextAnchor(builder: flatbuffers.Builder) {
    builder.startObject(2)
  }

  static addTextField(builder: flatbuffers.Builder, textFieldOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, textFieldOffset, 0)
  }

  static addSelection(builder: flatbuffers.Builder, selectionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, selectionOffset, 0)
  }

  static endTextAnchor(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 6) // selection
    return offset
  }
}
